import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import es from '../locales/es.json'
import en from '../locales/en.json'

export const SUPPORTED_LANGS = ['es', 'en'] as const
export type SupportedLang = (typeof SUPPORTED_LANGS)[number]

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { es: { translation: es }, en: { translation: en } },
    fallbackLng: 'es',
    supportedLngs: SUPPORTED_LANGS,
    interpolation: { escapeValue: false },
  })

export default i18n
